<template>
  <ShareComp indice="voice"/>
</template>

<script>

import gsap from "gsap"
import ShareComp from "./ShareComp"

export default {

  name: 'RecorderComp',
  render: h => h(),
  components: { ShareComp },
  data: ()=>({
    ready: false
  }),
  beforeDestroy() {
    this.$audio.removeEventListener('ended', this.audioEnded)
    this.$audio.remove()
  },
  computed: {
    status() { return this.$store.getters['app/status'] }
  },
  watch: {
    status(nw) {
      if(nw == 'start_recording') this.startRecording()
      else if(nw == 'stop_recording') this.stopRecording()
      else if(nw == 'listen_audio') this.listenAudio()
    },
  },

  mounted() {

    if (navigator.mediaDevices.getUserMedia) {

      const constraints = { audio: true };
      let chunks = [];

      let onSuccess = (stream)=> {

        this.$stream = stream
        this.$mediaRecorder = new MediaRecorder(stream)
        this.ready = true
 
        this.$mediaRecorder.onstop = (e)=> {

          // console.log("data available after MediaRecorder.stop() called.");

          cancelAnimationFrame(this.raf)

          this.$audio = document.createElement('audio')
          this.$audio.id = 'source'
          this.$audio.addEventListener('ended', this.audioEnded)

          // audio.controls = true;
          // const blob = new Blob(chunks, { 'type' : 'audio/ogg; codecs=opus' });

          this.$blob = new Blob(chunks, { 'type' : 'audio/mp3;' })
          chunks = []
          const audioURL = window.URL.createObjectURL(this.$blob)
          this.$audio.src = audioURL
        }

        this.$mediaRecorder.ondataavailable = function(e) {
          chunks.push(e.data);
        }
      }

      let onError = function(err) {
        console.log('The following error occured: ' + err)
      }

      navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError)

    } 

    // else {
    //   console.log('getUserMedia not supported on your browser!')
    // }

  },
  methods: { 

    audioEnded() {
      gsap.delayedCall(1, ()=> this.$store.commit('app/UPDATE_STATUS', 'audio_ended'))
    },
    startRecording (){
      this.visualize(this.$stream)
      this.$mediaRecorder.start()
    },
    stopRecording() {
      this.audioCtx = null
      this.$mediaRecorder.stop() 
    },
    listenAudio() {
      this.$audio.play()
      this.visualizeTrack(this.$audio)
    },

    visualizeTrack(stream){
      if(!this.audioCtx) {
        this.audioCtx = new AudioContext()
      }
      const source = this.audioCtx.createMediaElementSource(stream)
            source.connect(this.audioCtx.destination)
      this.analyser = this.audioCtx.createAnalyser()
      this.analyser.fftSize = 2048
      this.bufferLength = this.analyser.frequencyBinCount
      this.dataArray = new Uint8Array(this.bufferLength)
      source.connect(this.analyser)
      this.raf = requestAnimationFrame(this.draw); 
    },

    visualize(stream){
      if(!this.audioCtx) {
        this.audioCtx = new AudioContext()
      }
      const source = this.audioCtx.createMediaStreamSource(stream)
      this.analyser = this.audioCtx.createAnalyser()
      this.analyser.fftSize = 2048
      this.bufferLength = this.analyser.frequencyBinCount
      this.dataArray = new Uint8Array(this.bufferLength)
      source.connect(this.analyser)
      this.raf = requestAnimationFrame(this.draw);
      
    },
     draw() {
      this.raf = requestAnimationFrame(this.draw)
      this.analyser.getByteTimeDomainData(this.dataArray)
      for(let i = 0; i < this.bufferLength; i++) {
        let v = this.dataArray[i] / 128.0;
        this.$parent.analyser = v
      }
    }
  }

}
</script>


